import router from "@/router"
import RestPaths from "@/util/rest_paths"
import RouteNames from "@/util/route_names"
import store from "@/store"
import Poster from "@/util/poster"
import BaseLogic from "./base_logic"
import {
  Bestellung,
  AbholungStatus,
  LieferungStatus,
  Terminart,
  BestellungQueryRequest,
  RemoteResult,
  BestellungFiliale,
  ReservierungNeu,
  BuchungList,
  LoadState,
} from "mangdto"
import { EnumFormatter } from "mangutil"

export default class BestellungenLogic extends BaseLogic {
  bestellungen: Bestellung[] = []
  bestellungenAll: any[] = []
  reservierungen: ReservierungNeu[] = []
  listLoadState: LoadState = LoadState.Idle

  formatiereLieferungStatus(bestellung: Bestellung): string {
    return EnumFormatter.formatLieferungStatus(bestellung.lieferung.lieferungStatus)
  }

  formatiereAbholungStatus(bestellung: Bestellung): string {
    return EnumFormatter.formatAbholungStatus(bestellung.abholung.status)
  }

  formatTerminart(value: Terminart): string {
    return EnumFormatter.formatTerminart(value)
  }

  bestimmeBild(filiale: BestellungFiliale) {
    if (filiale.bildId != null) {
      return RestPaths.urlBase + RestPaths.imageImage + "/" + filiale.bildId
    }
  }

  detailsAnzeigen(bestellung: Bestellung) {
    router.push({
      name: RouteNames.BESTELLUNG_PAGE.DETAILS,
      params: { bestellungId: bestellung.id },
    })
  }

  reservierungAnzeigen(reservierung: ReservierungNeu) {
    router.push({
      name: RouteNames.RESERVIERUNG.DETAILS,
      params: { reservierungId: reservierung.id },
    })
  }

  abgeschlosseneAnzeigen() {
    router.push({ name: RouteNames.ABGESCHLOSSENE_BESTELLUNGEN })
  }

  init() {
    this.listLoadState = LoadState.Loading

    var request = new BestellungQueryRequest()
    request.identifier = store.state.user.identifier

    Poster.postUser<RemoteResult<BuchungList>>(
      RestPaths.bestellungKundeListeAll,
      request,
    )
      .then((response) => {
        if (response.data.success) {
          this.listLoadState = LoadState.Completed
          this.bestellungenAll = response.data.payload.list
        } else {
          this.listLoadState = LoadState.Error
        }
      })
      .catch(() => {
        this.listLoadState = LoadState.Error
      })
  }
}
